import React, { Component } from 'react';

class Footer extends Component {
  render(){
    return (
      <div className="sticky-bottom mt-5 pb-5">
    
    <div className="col">
        <div className={`d-flex mb-3 footer-${location.pathname.split("/")[2]}`}>
        






        </div>

    </div>
      </div>
    );
  }
}

export default Footer



// WEBPACK FOOTER //
// src/components/footer.jsx